import { useField } from 'formik'

import { ImageUpload, ImageUploadProps } from './ImageUpload'

type Props<T> = Omit<ImageUploadProps<T>, 'errorMessage' | 'onUploaded' | 'onError'> & {
  name: string
  accessor: (data: T) => unknown
}

const ImageUploadField = <T,>({ name, accessor, ...props }: Props<T>) => {
  const [, , helper] = useField(name)

  return (
    <ImageUpload
      {...props}
      onError={() => helper.setValue(undefined)}
      onUploaded={(file) => helper.setValue(accessor(file))}
    />
  )
}

export { ImageUploadField }
